import React, { useState, useEffect, useRef } from 'react';
import VobDocs from './components/VobDocs';

const API = 'https://tcio-api.onrender.com';
const dsafe = (d) => { if (!d) return ''; const s = String(d).slice(0,10); const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/); return (m ? new Date(+m[1], +m[2]-1, +m[3]) : new Date(d)).toLocaleDateString('en-US'); };

const STAGES = [
  { key:'new', label:'New' },
  { key:'contacted', label:'Contacted' },
  { key:'vob_pending', label:'VOB Pending' },
  { key:'vob_completed', label:'VOB Complete' },
  { key:'pending_admit', label:'Pending Admit' },
  { key:'prescreen_done', label:'Prescreen Done' },
  { key:'admitted', label:'Admitted' },
  { key:'lost', label:'Lost' },
];

const money = (n) => n ? '$' + Math.round(parseFloat(n)).toLocaleString() : '—';
const pct = (n) => n ? parseFloat(n).toFixed(1) + '%' : '—';
const dur = (s) => s ? `${Math.floor(s/60)}:${String(s%60).padStart(2,'0')}` : '—';
const when = (t) => t ? new Date(t).toLocaleString('en-US',
  { month:'short', day:'numeric', hour:'numeric', minute:'2-digit' }) : '';
const tierOf = (r) => {
  const v = parseFloat(r || 0);
  if (v >= 20) return { t:'A', c:'#16a34a' };
  if (v >= 10) return { t:'B', c:'#65a30d' };
  if (v >= 5)  return { t:'C', c:'#f59e0b' };
  return { t:'D', c:'#dc2626' };
};

// Opening another episode of the same client swaps the lead shown here; Back returns to the lead you came from.
export default function LeadDetail(props) {
  const [jump, setJump] = useState(null);
  return <LeadDetailInner key={jump || props.leadId} {...props} leadId={jump || props.leadId} onOpenLead={setJump} onBack={jump ? () => setJump(null) : props.onBack} />;
}

function LeadDetailInner({ leadId, user, onBack, onOpenLead }) {
  const [d, setD] = useState(null);
  const [lk, setLk] = useState(null);
  const [edit, setEdit] = useState(false);
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  const [tab, setTab] = useState('timeline');
  const [noteText, setNoteText] = useState('');
  const [showPending, setShowPending] = useState(false);
  const [paOrgs, setPaOrgs] = useState([]);
  useEffect(() => {
    if (!showPending || paOrgs.length) return;
    fetch(`${API}/api/organizations`, { headers })
      .then(r => r.json())
      .then(j => setPaOrgs((j.data || []).filter(o => o.active && !o.hidden && o.org_type === 'facility')))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPending]);
  const [playing, setPlaying] = useState(null);
  const [ai, setAi] = useState(null);
  const [aiBusy, setAiBusy] = useState(false);
  const [aiErr, setAiErr] = useState('');
  const [dict, setDict] = useState('');
  const [listening, setListening] = useState(false);
  const recogRef = useRef(null);

  const [psWriting, setPsWriting] = useState(false);
  const [psDone, setPsDone] = useState('');
  const writePrescreen = async (dictation) => {
    // Same engine as the Prescreen page (Chad ruling 2026-09-10): find or create
    // this lead's prescreen, run the rebuilt AI against it, save fills + ASAM.
    setPsWriting(true); setPsDone('');
    try {
      const g = await fetch(`${API}/api/prescreens?lead_id=${leadId}`, { headers });
      const gj = await g.json();
      let ps = gj.ok ? gj.data : null;
      if (!ps) {
        const cr = await fetch(`${API}/api/prescreens`, { method: 'POST', headers: jh,
          body: JSON.stringify({ lead_id: leadId, facility_id: d?.lead?.facility_id || undefined }) });
        const cj = await cr.json();
        if (!cj.ok) throw new Error(cj.error || 'could not create prescreen');
        ps = { id: cj.id };
      }
      const ar = await fetch(`${API}/api/prescreens/ai-assist`, { method: 'POST', headers: jh,
        body: JSON.stringify({ lead_id: leadId, current_form: ps, dictation: dictation || undefined }) });
      const aj = await ar.json();
      if (!aj.ok) throw new Error(aj.error || 'AI failed');
      if (aj.empty) { setPsDone(aj.message); setPsWriting(false); return; }
      const body = { ...(aj.fills || {}) };
      if (aj.asam) body.asam_summary = JSON.stringify(aj.asam);
      if (aj.gaps) body.ai_gaps = JSON.stringify(aj.gaps);
      const sv = await fetch(`${API}/api/prescreens/${ps.id}`, { method: 'PATCH', headers: jh,
        body: JSON.stringify(body) });
      const sj = await sv.json();
      if (!sj.ok) throw new Error(sj.error || 'save failed');
      setPsDone('\u2713 Prescreen written - open the Prescreen page to review the full document (ASAM, presenting problem, LOC recommendation).');
    } catch (e) { setPsDone('Prescreen generation failed: ' + e.message); }
    setPsWriting(false);
  };

  const runLeadAi = async (dictation) => {
    if (!dictation && ai?.generated_at) {
      const newer = (d?.transcripts || []).some(t =>
        t.transcript_status === 'complete' && t.call_started_at &&
        new Date(t.call_started_at) > new Date(ai.generated_at));
      if (!newer && !window.confirm('No new calls since the last analysis. Re-run anyway?')) return;
    }
    setAiBusy(true); setAiErr('');
    try {
      const r = await fetch(`${API}/api/leads/${leadId}/ai-assist`, {
        method: 'POST', headers: jh,
        body: JSON.stringify({ dictation: dictation || undefined }),
      });
      const j = await r.json();
      if (!j.ok) setAiErr(j.error || 'AI failed');
      else if (j.empty) setAiErr(j.message);
      else { setAi(j); if (dictation) setDict(''); await load(); writePrescreen(dictation); }
    } catch (e) { setAiErr('Connection error'); }
    setAiBusy(false);
  };

  const toggleMic = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { setAiErr('Dictation needs Chrome or Safari.'); return; }
    if (listening) { recogRef.current?.stop(); setListening(false); return; }
    const rec = new SR();
    rec.continuous = true; rec.interimResults = true; rec.lang = 'en-US';
    let committed = '';
    rec.onstart = () => { setDict(prev => { committed = prev; return prev; }); };
    rec.onresult = (e) => {
      let finals = '', interim = '';
      for (let i = 0; i < e.results.length; i++) {
        if (e.results[i].isFinal) finals += e.results[i][0].transcript + ' ';
        else interim += e.results[i][0].transcript + ' ';
      }
      setDict((committed + ' ' + finals + interim).trim());
    };
    rec.onend = () => setListening(false);
    recogRef.current = rec; rec.start(); setListening(true);
  };

  const URGENCY_STYLE = {
    ADMIT_NOW: { bg:'#fee2e2', fg:'#991b1b', label:'🚨 ADMIT NOW' },
    HOT:       { bg:'#ffedd5', fg:'#9a3412', label:'🔥 HOT' },
    WARM:      { bg:'#fef9c3', fg:'#854d0e', label:'🌤 WARM' },
    NURTURE:   { bg:'#e0f2fe', fg:'#075985', label:'🌱 NURTURE' },
  };
  const [hist, setHist] = useState(null);
  const [admitEdit, setAdmitEdit] = useState(null); // null = not editing; otherwise YYYY-MM-DD

  const headers = { Authorization: `Bearer ${user.token}` };
  const jh = { ...headers, 'Content-Type': 'application/json' };
  const isAdmin = ['ceo','admin'].includes(user.role);

  const load = async () => {
    const r = await fetch(`${API}/api/leads/v2/${leadId}`, { headers });
    const j = await r.json();
    if (j.ok) {
      setD(j);
      if (j.lead?.ai_sales_analysis) {
        const cached = typeof j.lead.ai_sales_analysis === 'string' ? JSON.parse(j.lead.ai_sales_analysis) : j.lead.ai_sales_analysis;
        setAi(prev => prev || cached);
      }
      const l = j.lead, v = j.vob || {};
      setF({
        first_name: l.first_name || '', last_name: l.last_name || '',
        phone: l.phone || '', email: l.email || '',
        dob: l.dob ? l.dob.split('T')[0] : '', gender: l.gender || '',
        caller_name: l.caller_name || '', caller_relationship: l.caller_relationship || '',
        caller_phone: l.caller_phone || '',
        emergency_contact_name: l.emergency_contact_name || '',
        emergency_contact_relationship: l.emergency_contact_relationship || '',
        emergency_contact_phone: l.emergency_contact_phone || '',
        facility_id: l.facility_id || '', loc_requested: l.loc_requested || '', payment_type: l.payment_type || 'insurance',
        payer_name: v.payer_name || '', plan_name: v.plan_name || '',
        member_id: v.member_id || '', group_number: v.group_number || '',
        secondary_payer_name: v.secondary_payer_name || '', secondary_plan_name: v.secondary_plan_name || '',
        secondary_member_id: v.secondary_member_id || '',
        rx_bin: v.rx_bin || '', rx_pcn: v.rx_pcn || '',
        deductible: v.deductible ?? '', deductible_met: v.deductible_met ?? '',
        oop_max: v.oop_max ?? '', oop_met: v.oop_met ?? '',
        oon_coverage_pct: v.oon_coverage_pct ?? '',
        in_network: v.in_network ?? '', oon_coverage: v.oon_coverage ?? '',
        auth_required: v.auth_required ?? '', mental_health_benefit: v.mental_health_benefit ?? '',
        auth_number: v.auth_number || '',
        auth_thru: v.auth_thru ? v.auth_thru.split('T')[0] : '',
        primary_substance: l.primary_substance || '', last_use: l.last_use || '',
        detox_risk: l.detox_risk || '', prior_treatment: l.prior_treatment ?? '',
        mh_diagnosis: l.mh_diagnosis || '', si_hi: l.si_hi ?? '',
        how_soon: l.how_soon || '', patient_state: l.patient_state || '',
        needs_transport: l.needs_transport ?? '',
        lead_source_id: l.lead_source_id || '',
        referral_partner_id: l.referral_partner_id || '',
        therapist_id: l.therapist_id || '', case_manager_id: l.case_manager_id || '',
        coordinator_id: l.coordinator_id || '',
        notes: l.notes || '',
      });
    }
  };

  // the stay the admit line is about: the current one, else the newest that was not a reversed admission
  const admitStay = (h) => { const eps = (h && h.episodes) || []; return eps.find(x => (x.discharge_date ? false : true)) || eps.find(x => (x.discharge_type === 'never_admitted') === false) || eps[0] || null; };
  const fmtAdmit = (d) => { const x = String(d || '').slice(0, 10); return x.length === 10 ? x.slice(5, 7) + '/' + x.slice(8, 10) + '/' + x.slice(0, 4) : x; };
  const saveAdmitDate = async () => {
    const ep = hist && hist.episodes && admitStay(hist);
    if (!ep || !admitEdit) return;
    if (admitEdit === String(ep.admit_date).slice(0, 10)) { setAdmitEdit(null); return; }
    try {
      const r = await fetch(`${API}/api/episode/${ep.id}/details`, { method: 'PATCH',
        headers: { ...headers, 'Content-Type': 'application/json' }, body: JSON.stringify({ admit_date: admitEdit }) });
      const j = await r.json();
      if (!j.ok) { alert(j.error || 'Could not change the admit date.'); return; }
      setAdmitEdit(null);
      loadHist();
      alert('Admit date updated. The change is recorded. If billing has already run for this client, click Refresh on Ready to Bill so the billing days line up.');
    } catch (e) { alert('Could not change the admit date.'); }
  };
  const loadHist = () =>
    fetch(`${API}/api/leads/v2/${leadId}/history`, { headers })
      .then(r => r.json()).then(j => j.ok && setHist(j)).catch(() => {});

  useEffect(() => {
    load();
    loadHist();
    fetch(`${API}/api/lookups`, { headers }).then(r => r.json())
      .then(j => j.ok && setLk(j)).catch(() => {});
  }, [leadId]);

  const flagDNA = async () => {
    const reason = prompt('Why should this person not be readmitted?');
    if (!reason) return;
    const r = await fetch(`${API}/api/contacts/${lead.contact_id}/do-not-admit`, {
      method:'POST', headers: jh, body: JSON.stringify({ reason })
    });
    const j = await r.json();
    if (!j.ok) alert(j.error); else loadHist();
  };

  const clearDNA = async () => {
    if (!window.confirm('Clear the Do Not Admit flag?')) return;
    const r = await fetch(`${API}/api/contacts/${lead.contact_id}/do-not-admit`, {
      method:'DELETE', headers
    });
    const j = await r.json();
    if (!j.ok) alert(j.error); else loadHist();
  };

  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  // ADD A LEAD SOURCE (ticket bed45586, Chad 10/5): from the lead itself, saved to the person's own organization.
  const addSource = async () => {
    const name = (window.prompt('Name of the new lead source:') || '').trim();
    if (name.length === 0) return;
    try {
      const r = await fetch(`${API}/api/lead-sources`, { method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' }, body: JSON.stringify({ name }) });
      const j = await r.json();
      if (j.ok === true && j.data) {
        setLk(k => ({ ...k, lead_sources: [...(k.lead_sources || []).filter(x => (x.id === j.data.id) === false), j.data].sort((x, y) => String(x.name).localeCompare(String(y.name))) }));
        set('lead_source_id', j.data.id);
      } else alert(j.error === 'Forbidden' ? 'You do not have permission to add a lead source.' : (j.error || 'Could not add the lead source.'));
    } catch (e) { alert('Could not add the lead source.'); }
  };

  const save = async () => {
    setBusy(true);
    const r = await fetch(`${API}/api/leads/v2/${leadId}/full`, {
      method:'PUT', headers: jh, body: JSON.stringify(f)
    });
    const j = await r.json();
    if (!j.ok) alert('Error: ' + j.error);
    else {
      if (j.warning) alert(j.warning);
      setEdit(false); await load();
    }
    setBusy(false);
  };

  const act = async (url, body, method='POST') => {
    setBusy(true);
    const r = await fetch(`${API}${url}`, { method, headers: jh, body: JSON.stringify(body||{}) });
    const j = await r.json();
    if (!j.ok) alert('Error: ' + j.error);
    await load();
    setBusy(false);
    return j;
  };

  const addPartner = async () => {
    const name = prompt('New referral partner name:');
    if (!name) return;
    const r = await fetch(`${API}/api/referral-partners`, {
      method:'POST', headers: jh, body: JSON.stringify({ name })
    });
    const j = await r.json();
    if (j.ok) {
      const lr = await fetch(`${API}/api/lookups`, { headers });
      const lj = await lr.json();
      setLk(lj);
      set('referral_partner_id', j.data.id);
    }
  };

  const addStaff = async (type) => {
    const name = prompt(`New ${type.replace('_',' ')} — first name:`);
    if (!name) return;
    const last = prompt('Last name (optional):');
    const r = await fetch(`${API}/api/staff`, {
      method:'POST', headers: jh,
      body: JSON.stringify({ first_name: name, last_name: last || null, staff_type: type })
    });
    const j = await r.json();
    if (j.ok) {
      const lr = await fetch(`${API}/api/lookups`, { headers });
      setLk(await lr.json());
      set(type === 'therapist' ? 'therapist_id' : 'case_manager_id', j.data.id);
    }
  };

  const playCall = async (callId) => {
    if (playing === callId) return setPlaying(null);
    const r = await fetch(`${API}/api/calls/${callId}/recording`, { headers });
    const j = await r.json();
    if (!j.ok) return alert('No recording');
    setPlaying(callId);
    setD(p => ({ ...p, transcripts: p.transcripts.map(t =>
      t.call_id === callId ? { ...t, _audio: j.url } : t) }));
  };

  if (!d || !lk) return <div style={s.wrap}><div style={s.empty}>Loading…</div></div>;

  const { lead, vob, payerIntel, transcripts, activity, alumni } = d;
  const otherEpisodes = Array.isArray(d.other_episodes) ? d.other_episodes : [];
  const primary = payerIntel.find(p => p.loc === (lead.loc_requested || 'RTC')) || payerIntel[0];
  const tier = primary ? tierOf(primary.actual_collected_rate) : null;
  const isCold = lead.days_since_activity >= 5;

  const staffName = (x) => x ? `${x.first_name} ${x.last_name || ''}`.trim() : '';

  return (
    <div style={s.wrap}>
      <button onClick={onBack} style={s.back}>← Back to Leads</button>

      <div style={s.header}>
        <div>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <h1 style={s.h1}>{lead.first_name} {lead.last_name}</h1>
            {isCold && <span style={s.coldFlag}>{lead.days_since_activity}d no activity</span>}
          </div>
          <div style={s.dim}>{lead.phone} {lead.email && `· ${lead.email}`}</div>
          <div style={s.dim}>{lead.facility_name} {lead.loc_requested && `· ${lead.loc_requested}`}</div>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <select value={lead.assigned_to || ''} disabled={busy} style={s.input}
            onChange={e => act(`/api/leads/v2/${leadId}/assign`, { user_id: e.target.value }, 'PATCH')}>
            <option value="">Unassigned</option>
            {lk.reps.map(r => <option key={r.id} value={r.id}>{r.first_name} {r.last_name}</option>)}
          </select>
          <select value={lead.pipeline_stage} disabled={busy} style={s.input}
            onChange={e => { if (e.target.value === 'admitted' && hist && ((hist.episodes || []).some(x => (x.discharge_date ? false : true))) === false) { alert('A lead becomes Admitted when the client is placed in a bed. On the Bed Board, use Assign Bed, or Arrived on the pending card for this client. The lead will then change to Admitted by itself and show the admit date.'); return; } act(`/api/leads/v2/${leadId}/stage`, { stage: e.target.value }, 'PATCH'); }}>
            {STAGES.map(st => <option key={st.key} value={st.key}>{st.label}</option>)}
          </select>
          {lead.pipeline_stage === 'admitted' && hist && (admitStay(hist) ? false : true) && (
            <span style={{ fontSize:12.5, color:'#b45309', fontWeight:600 }}>Marked Admitted, but not in a bed yet. Place the client on the Bed Board and the admit date will appear here.</span>
          )}
          {lead.pipeline_stage === 'admitted' && hist && hist.episodes && admitStay(hist) && (
            <span style={{ display:'inline-flex', alignItems:'center', gap:6, fontSize:12.5, color:'#5D6B7A', flexWrap:'wrap' }}>
              {admitEdit === null ? (
                <>
                  <span>{'Admitted ' + fmtAdmit(admitStay(hist).admit_date) + (admitStay(hist).facility_name ? ' at ' + admitStay(hist).facility_name : '')}</span>
                  {true && <button type="button" onClick={() => setAdmitEdit(String(admitStay(hist).admit_date).slice(0, 10))} style={{ padding:'3px 9px', fontSize:12, fontWeight:500, borderRadius:6, border:'1px solid #D8E3EE', background:'#fff', color:'#0878E8', cursor:'pointer' }}>Change</button>}
                </>
              ) : (
                <>
                  <input type="date" value={admitEdit} onChange={e => setAdmitEdit(e.target.value)} style={{ padding:'4px 6px', border:'1px solid #D8E3EE', borderRadius:6, fontSize:12.5 }} />
                  <button type="button" onClick={saveAdmitDate} style={{ padding:'3px 9px', fontSize:12, fontWeight:500, borderRadius:6, border:'1px solid #D8E3EE', background:'#fff', color:'#0878E8', cursor:'pointer' }}>Save</button>
                  <button type="button" onClick={() => setAdmitEdit(null)} style={{ padding:'3px 9px', fontSize:12, fontWeight:500, borderRadius:6, border:'1px solid #D8E3EE', background:'#fff', color:'#5D6B7A', cursor:'pointer' }}>Cancel</button>
                </>
              )}
            </span>
          )}
        </div>
      </div>

      {otherEpisodes.length > 0 && (
        <div style={{ border:'1px solid #D8E3EE', background:'#F4F8FC', borderRadius:10, padding:'10px 14px', margin:'0 0 14px' }}>
          <div style={{ fontSize:13.5, fontWeight:700, color:'#1F2A37' }}>
            {otherEpisodes.some(e => !e.later) ? 'Returning client' : 'This client came back later'}
            <span style={{ fontWeight:400, color:'#5D6B7A' }}>{' · same client record, ' + otherEpisodes.length + (otherEpisodes.length === 1 ? ' other episode' : ' other episodes')}</span>
          </div>
          {otherEpisodes.map(e => (
            <div key={e.id} onClick={() => onOpenLead && onOpenLead(e.id)} title="Open this episode" style={{ fontSize:12.5, color:'#0878E8', marginTop:4, cursor:'pointer' }}>
              {[(e.later ? 'Later' : 'Earlier') + ' episode: ' + String(e.pipeline_stage || '').replace(/_/g, ' '),
                e.created_at ? 'started ' + new Date(e.created_at).toLocaleDateString('en-US') : null,
                e.facility_name, e.loc_requested,
                e.payer_name ? 'insurance then: ' + e.payer_name : null,
                e.lost_reason ? 'lost: ' + e.lost_reason : null].filter(Boolean).join(' · ')}
            </div>
          ))}
          {otherEpisodes.some(e => !e.later) && (
            <div style={{ fontSize:12.5, color:'#1F2A37', marginTop:8 }}>Insurance is not carried over from an earlier episode. Enter the current insurance and run a new VOB for this one.</div>
          )}
        </div>
      )}
      {primary && (
        <div style={{ ...s.card, borderLeft:`4px solid ${tier.c}` }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
            <span style={{ ...s.tierBig, background:tier.c }}>{tier.t}</span>
            <span style={{ fontSize:16, fontWeight:700 }}>{vob.payer_name}</span>
            <span style={s.dim}>· real payment history</span>
          </div>
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
            <thead><tr>
              {['LOC','Day Rate','Avg LOS','Episode Value','Collection'].map((h,i) =>
                <th key={h} style={{ textAlign: i===0?'left':'right', padding:'6px 10px',
                  fontSize:10, fontWeight:800, color:'#94a3b8', textTransform:'uppercase',
                  letterSpacing:'0.05em', borderBottom:'1px solid #e2e8f0' }}>{h}</th>)}
            </tr></thead>
            <tbody>
              {[...payerIntel]
                .sort((a,b)=>({DTX:1,RTC:2,PHP:3,IOP:4}[a.loc]||9)-({DTX:1,RTC:2,PHP:3,IOP:4}[b.loc]||9))
                .map((r,i) => {
                const isReq = r.loc === (lead.loc_requested || null);
                return (
                <tr key={i} style={{ borderTop:'1px solid #f1f5f9',
                  background: isReq ? '#eff6ff' : 'transparent', fontWeight: isReq ? 700 : 400 }}>
                  <td style={{ padding:'7px 10px', fontWeight:700 }}>
                    {r.loc}{isReq && <span style={{ fontSize:10, color:'#2563eb', marginLeft:6 }}>REQUESTED</span>}
                  </td>
                  <td style={{ padding:'7px 10px', textAlign:'right' }}>{money(r.avg_day_rate_collected)}{r.rate_source === 'company' ? <div style={{ fontSize: 10, color: '#94a3b8' }}>company avg</div> : null}</td>
                  <td style={{ padding:'7px 10px', textAlign:'right' }}>{r.avg_los_actual ? `${r.avg_los_actual} days` : '—'}</td>
                  <td style={{ padding:'7px 10px', textAlign:'right', color:'#16a34a', fontWeight:700 }}>{money(r.avg_episode_value)}</td>
                  <td style={{ padding:'7px 10px', textAlign:'right' }}>{pct(r.actual_collected_rate)}</td>
                </tr>
              );})}
            </tbody>
          </table>
        </div>
      )}

      {hist?.do_not_admit && (
        <div style={s.dnaBanner}>
          <div style={{ fontSize:18, fontWeight:900, marginBottom:4 }}>🚫 DO NOT ADMIT</div>
          <div style={{ fontSize:14 }}>{hist.dna_reason}</div>
          <div style={{ fontSize:12, opacity:0.85, marginTop:6 }}>
            Flagged by {hist.dna_flagged_by} · {hist.dna_flagged_at && dsafe(hist.dna_flagged_at)}
          </div>
          {isAdmin && (
            <button onClick={clearDNA} style={s.dnaClear}>Clear flag</button>
          )}
        </div>
      )}

      {hist && hist.prior_stays > 0 && (
        <div style={{ ...s.card, background:'#fffbeb', borderColor:'#fde68a' }}>
          <div style={s.rowBetween}>
            <div style={s.cardTitle}>
              ⚠️ Prior history — {hist.prior_stays} stay{hist.prior_stays > 1 ? 's' : ''} · {hist.total_days} days total
            </div>
            {isAdmin && !hist.do_not_admit && (
              <button onClick={flagDNA} title="Flag this person as Do Not Admit"
                style={{ background:'transparent', color:'#b91c1c', border:'1px dashed #fca5a5', borderRadius:8, padding:'6px 12px', fontSize:12, fontWeight:600, cursor:'pointer' }}>
                Flag as Do Not Admit…</button>
            )}
          </div>

          {hist.payer_history.length > 0 && (
            <div style={{ marginTop:12 }}>
              <div style={{ fontSize:11, fontWeight:800, color:'#92400e',
                            textTransform:'uppercase', marginBottom:6 }}>
                What insurance actually paid us
              </div>
              <table style={{ width:'100%', fontSize:13, borderCollapse:'collapse' }}>
                <thead><tr>
                  {['Payer','Claims','Billed','Collected','Rate'].map(h =>
                    <th key={h} style={s.hTh}>{h}</th>)}
                </tr></thead>
                <tbody>
                  {hist.payer_history.map((p,i) => (
                    <tr key={i} style={{ borderTop:'1px solid #fde68a',
                          background: p.never_paid ? '#fef2f2' : 'transparent' }}>
                      <td style={s.hTd}>
                        {p.never_paid && '🚨 '}{p.payer}
                      </td>
                      <td style={s.hTd}>{p.claims}</td>
                      <td style={s.hTd}>{money(p.billed)}</td>
                      <td style={{ ...s.hTd, fontWeight:700,
                            color: p.never_paid ? '#dc2626' : '#16a34a' }}>
                        {money(p.collected)}
                      </td>
                      <td style={s.hTd}>{p.collection_rate}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ marginTop:8, fontSize:14, fontWeight:800, color:'#92400e' }}>
                Total collected from this patient: {money(hist.total_collected)}
              </div>
              {hist.payer_history.some(p => p.never_paid) && (
                <div style={s.warn}>
                  🚨 One or more payers have <strong>never paid us</strong> for this patient.
                  Verify current coverage before admitting.
                </div>
              )}
            </div>
          )}

          <div style={{ marginTop:14 }}>
            <div style={{ fontSize:11, fontWeight:800, color:'#92400e',
                          textTransform:'uppercase', marginBottom:6 }}>Stays</div>
            {[...hist.episodes.map(e => ({
                date: e.admit_date, dc: e.discharge_date, los: e.los_days,
                type: e.discharge_type, payer: e.primary_payer, loc: e.loc, src: 'TCIO'
              })),
              ...hist.dazos.map(d => ({
                date: d.admission_date, dc: d.discharge_date, los: d.los_days,
                type: d.discharge_type, payer: d.insurance_company, loc: d.loc, src: 'Dazos'
              }))].map((x,i) => (
              <div key={i} style={{ fontSize:13, color:'#92400e', marginTop:3 }}>
                {x.date ? dsafe(x.date) : '—'}
                {x.loc ? ` · ${x.loc}` : ''}
                {x.los ? ` · ${x.los} days` : ''}
                {x.payer ? ` · ${x.payer}` : ''}
                {x.type && x.type !== 'Unknown' ? ` · ${x.type}` : ''}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── PATIENT RECORD ── */}
      <div style={s.card}>
        <div style={s.rowBetween}>
          <div style={s.cardTitle}>Patient Record</div>
          {!edit
            ? <button onClick={() => setEdit(true)} style={s.btn}>✏️ Edit</button>
            : <div style={{ display:'flex', gap:8 }}>
                <button disabled={busy} onClick={save} style={s.btnGreen}>
                  {busy ? 'Saving…' : 'Save'}
                </button>
                <button onClick={() => { setEdit(false); load(); }} style={s.btn}>Cancel</button>
              </div>}
        </div>

        <Section title="Patient" />
        <Grid>
          <F l="First Name"  edit={edit} v={f.first_name} on={v=>set('first_name',v)} show={lead.first_name} />
          <F l="Last Name"   edit={edit} v={f.last_name}  on={v=>set('last_name',v)}  show={lead.last_name} />
          <F l="Phone"       edit={edit} v={f.phone}      on={v=>set('phone',v)}      show={lead.phone} />
          <F l="Email"       edit={edit} v={f.email}      on={v=>set('email',v)}      show={lead.email} />
          <F l="DOB" type="date" edit={edit} v={f.dob}    on={v=>set('dob',v)}
             show={lead.dob ? dsafe(lead.dob) : ''} />
          <F l="Gender" edit={edit} v={f.gender} on={v=>set('gender',v)} show={lead.gender}
             opts={['','male','female','other']} />
          <F l="State" edit={edit} v={f.patient_state} on={v=>set('patient_state',v)} show={lead.patient_state} />
        </Grid>

        <Section title="Caller (if not the patient)" />
        <Grid>
          <F l="Caller Name" edit={edit} v={f.caller_name} on={v=>set('caller_name',v)} show={lead.caller_name} />
          <F l="Relationship" edit={edit} v={f.caller_relationship} on={v=>set('caller_relationship',v)}
             show={lead.caller_relationship} opts={['', ...lk.relationships]} />
          <F l="Caller Phone" edit={edit} v={f.caller_phone} on={v=>set('caller_phone',v)} show={lead.caller_phone} />
        </Grid>

        <Section title="Emergency Contact" />
        {edit && (
          <button onClick={() => { set('emergency_contact_name', f.caller_name); set('emergency_contact_relationship', f.caller_relationship); set('emergency_contact_phone', f.caller_phone); }}
            style={{ marginBottom: 8, padding: '4px 12px', fontSize: 12, fontWeight: 600, background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: 6, cursor: 'pointer' }}>
            ⤓ Same as caller
          </button>
        )}
        <Grid>
          <F l="Emergency Contact Name" edit={edit} v={f.emergency_contact_name} on={v=>set('emergency_contact_name',v)} show={lead.emergency_contact_name} />
          <F l="Relationship" edit={edit} v={f.emergency_contact_relationship} on={v=>set('emergency_contact_relationship',v)}
             show={lead.emergency_contact_relationship} opts={['', ...lk.relationships]} />
          <F l="Emergency Contact Phone" edit={edit} v={f.emergency_contact_phone} on={v=>set('emergency_contact_phone',v)} show={lead.emergency_contact_phone} />
        </Grid>

        <Section title="Insurance / VOB" />
        <Grid>
          <F l="Payer" edit={edit} v={f.payer_name} on={v=>set('payer_name',v)}
             show={vob?.payer_name} opts={['', ...lk.payers]} wide searchable />
          <F l="Plan Name" edit={edit} v={f.plan_name} on={v=>set('plan_name',v)} show={vob?.plan_name} />
          <F l="Member ID" edit={edit} v={f.member_id} on={v=>set('member_id',v)} show={vob?.member_id} />
          <F l="Group #" edit={edit} v={f.group_number} on={v=>set('group_number',v)} show={vob?.group_number} />
          <F l="Secondary Payer" edit={edit} v={f.secondary_payer_name} on={v=>set('secondary_payer_name',v)}
             show={vob?.secondary_payer_name} opts={['', ...lk.payers]} wide searchable />
          <F l="Secondary Plan" edit={edit} v={f.secondary_plan_name} on={v=>set('secondary_plan_name',v)} show={vob?.secondary_plan_name} />
          <F l="Secondary Member ID" edit={edit} v={f.secondary_member_id} on={v=>set('secondary_member_id',v)} show={vob?.secondary_member_id} />
          <F l="RX BIN" edit={edit} v={f.rx_bin} on={v=>set('rx_bin',v)} show={vob?.rx_bin} />
          <F l="RX PCN" edit={edit} v={f.rx_pcn} on={v=>set('rx_pcn',v)} show={vob?.rx_pcn} />
          <F l="In Network?" edit={edit} v={f.in_network} on={v=>set('in_network',v)}
             show={vob?.in_network === true ? 'Yes' : vob?.in_network === false ? 'No' : ''}
             opts={[['','—'],['true','Yes'],['false','No']]} />
          <F l="Deductible" type="number" edit={edit} v={f.deductible} on={v=>set('deductible',v)} show={vob?.deductible && money(vob.deductible)} />
          <F l="Deductible Met" type="number" edit={edit} v={f.deductible_met} on={v=>set('deductible_met',v)} show={vob?.deductible_met && money(vob.deductible_met)} />
          <F l="OOP Max" type="number" edit={edit} v={f.oop_max} on={v=>set('oop_max',v)} show={vob?.oop_max && money(vob.oop_max)} />
          <F l="OOP Met" type="number" edit={edit} v={f.oop_met} on={v=>set('oop_met',v)} show={vob?.oop_met && money(vob.oop_met)} />
          <F l="OON %" type="number" edit={edit} v={f.oon_coverage_pct} on={v=>set('oon_coverage_pct',v)} show={vob?.oon_coverage_pct && vob.oon_coverage_pct + '%'} />
          <F l="Auth Required" edit={edit} v={f.auth_required} on={v=>set('auth_required',v)}
             show={vob?.auth_required === true ? 'Yes' : vob?.auth_required === false ? 'No' : ''}
             opts={[['','—'],['true','Yes'],['false','No']]} />
          <F l="MH Benefit" edit={edit} v={f.mental_health_benefit} on={v=>set('mental_health_benefit',v)}
             show={vob?.mental_health_benefit === true ? 'Yes' : vob?.mental_health_benefit === false ? 'No' : ''}
             opts={[['','—'],['true','Yes'],['false','No']]} />
          <F l="Auth #" edit={edit} v={f.auth_number} on={v=>set('auth_number',v)} show={vob?.auth_number} />
          <F l="Auth Thru" type="date" edit={edit} v={f.auth_thru} on={v=>set('auth_thru',v)}
             show={vob?.auth_thru ? dsafe(vob.auth_thru) : ''} />
        </Grid>

        <VobDocs leadId={leadId} user={user} />

        <Section title="Clinical" />
        <Grid>
          <F l="Primary Substance" edit={edit} v={f.primary_substance} on={v=>set('primary_substance',v)}
             show={lead.primary_substance} opts={['', ...lk.substances]} />
          <F l="Last Use" edit={edit} v={f.last_use} on={v=>set('last_use',v)} show={lead.last_use} />
          <F l="Detox Risk" edit={edit} v={f.detox_risk} on={v=>set('detox_risk',v)}
             show={lead.detox_risk} opts={['', ...lk.detox_risk]} />
          <F l="Prior Treatment" edit={edit} v={f.prior_treatment} on={v=>set('prior_treatment',v)}
             show={lead.prior_treatment === true ? 'Yes' : lead.prior_treatment === false ? 'No' : ''}
             opts={[['','—'],['true','Yes'],['false','No']]} />
          <F l="SI / HI" edit={edit} v={f.si_hi} on={v=>set('si_hi',v)}
             show={lead.si_hi === true ? '⚠️ Yes' : lead.si_hi === false ? 'No' : ''}
             opts={[['','—'],['true','Yes'],['false','No']]} />
          <F l="MH Diagnosis" edit={edit} v={f.mh_diagnosis} on={v=>set('mh_diagnosis',v)} show={lead.mh_diagnosis} wide />
        </Grid>

        <Section title="Logistics" />
        <Grid>
          <F l="Facility" edit={edit} v={f.facility_id} on={v=>set('facility_id',v)}
             show={lead.facility_name}
             opts={[['','—'], ...lk.facilities.map(x=>[x.id, x.org_name])]} />
          <F l="LOC" edit={edit} v={f.loc_requested} on={v=>set('loc_requested',v)}
             show={lead.loc_requested} opts={['', ...lk.locs]} />
          <F l="Payment Type" edit={edit} v={f.payment_type} on={v=>set('payment_type',v)}
             show={lead.payment_type} opts={['insurance', 'scholarship', 'cash', 'single_case_agreement']} />
          <F l="How Soon" edit={edit} v={f.how_soon} on={v=>set('how_soon',v)}
             show={lead.how_soon} opts={['', ...lk.how_soon]} />
          <F l="Needs Transport" edit={edit} v={f.needs_transport} on={v=>set('needs_transport',v)}
             show={lead.needs_transport === true ? 'Yes' : lead.needs_transport === false ? 'No' : ''}
             opts={[['','—'],['true','Yes'],['false','No']]} />
        </Grid>

        <Section title="Attribution" />
        <Grid>
          <F l="Lead Source" edit={edit} v={f.lead_source_id} on={v=>set('lead_source_id',v)}
             show={lead.lead_source_name}
             opts={[['','—'], ...lk.lead_sources.map(x=>[x.id, x.name])]}
             onAdd={edit ? addSource : null} />
          <F l="Referral Partner" edit={edit} v={f.referral_partner_id} on={v=>set('referral_partner_id',v)}
             show={lead.referral_partner_name}
             opts={[['','—'], ...lk.referral_partners.map(x=>[x.id, x.name])]}
             onAdd={edit ? addPartner : null} />
        </Grid>

        <Section title="Clinical Team (carries to Bed Board)" />
        <Grid>
          <F l="Admissions Rep" edit={edit} v={lead.assigned_to || ''}
             on={v=>act(`/api/leads/v2/${leadId}/assign`, { user_id: v || null }, 'PATCH')}
             show={(() => { const r = lk.reps.find(x => x.id === lead.assigned_to); return r ? `${r.first_name} ${r.last_name}` : null; })()}
             opts={[['','Unassigned'], ...lk.reps.map(x=>[x.id, `${x.first_name} ${x.last_name}`])]} />
          <F l="Therapist" edit={edit} v={f.therapist_id} on={v=>set('therapist_id',v)}
             show={lead.therapist_name}
             opts={[['','—'], ...lk.therapists.map(x=>[x.id, staffName(x)])]}
             onAdd={edit ? () => addStaff('therapist') : null} />
          <F l="Case Manager" edit={edit} v={f.case_manager_id} on={v=>set('case_manager_id',v)}
             show={lead.case_manager_name}
             opts={[['','—'], ...lk.case_managers.map(x=>[x.id, staffName(x)])]}
             onAdd={edit ? () => addStaff('case_manager') : null} />
          <F l="Coordinator" edit={edit} v={f.coordinator_id} on={v=>set('coordinator_id',v)}
             show={lead.coordinator_name}
             opts={[['','—'], ...lk.coordinators.map(x=>[x.id, `${x.first_name} ${x.last_name}`])]} />
        </Grid>
      </div>

      {/* ACTIONS */}
      <div style={s.actions}>
        <button disabled={busy} style={s.btnCall} onClick={async () => {
          const r = await fetch(`${API}/api/call/dial`, {
            method:'POST', headers: jh, body: JSON.stringify({ lead_id: leadId })
          });
          const j = await r.json();
          if (j.ok) alert(j.message);
          else if (j.error === 'no_phone') {
            const p = prompt('Enter your cell — CallRail will ring you first:');
            if (p) {
              await fetch(`${API}/api/me/phone`, {
                method:'PATCH', headers: jh, body: JSON.stringify({ phone: p })
              });
              alert('Saved. Click Call again.');
            }
          } else alert('Could not place call: ' + j.error);
        }}>📞 Call</button>
        <button disabled={busy} onClick={() => act(`/api/leads/v2/${leadId}/log-call`, { outcome:'Called' })} style={s.btn}>Log Call</button>
        <button disabled={busy} style={s.btnBlue} onClick={async () => {
          await save();   // what's on screen is what the VOB check sees
          // one button: a facility that verifies in-house sends the request to the VOB work queue; any other carries on to the email below
          const f0r = await fetch(`${API}/api/vob/queue/${leadId}/lead-request`, { method:'POST', headers: jh, body: JSON.stringify({}) }).catch(() => null);
          const f0 = f0r ? await f0r.json().catch(() => ({})) : {};
          if (f0.mode === 'in_house') {
            if (!f0.ok) { alert('Error: ' + (f0.error || 'The VOB was not requested')); return; }
            let line = 'Already on file.';
            if (!f0.already) { let cj = {}; try { const cr = await fetch(`${API}/api/vob/workspace/${leadId}/check`, { method:'POST', headers: jh, body: JSON.stringify({}) }); cj = await cr.json().catch(() => ({})); } catch (e) { cj = {}; }
              line = cj.ok ? cj.message : cj.repeat ? 'It was already run a few minutes ago.' : (cj.error || 'It did not run.'); }
            alert(`${f0.already ? 'A VOB request is already open for this client' : 'VOB requested'}\nRef: ${f0.ref_code}\n\nElectronic check: ${line}\n\nIt is on the VOB work queue. You will be notified when the VOB is complete.`);
            await load(); return;
          }
          const r0 = await fetch(`${API}/api/leads/v2/${leadId}/request-vob`, { method:'POST', headers: jh, body: JSON.stringify({}) });
          const j0 = await r0.json();
          if (j0.ok) { alert(`VOB requested from Biller\nRef: ${j0.ref_code}`); await load(); }
          else if (j0.duplicate) {
            const p = j0.prior;
            const when = new Date(p.requested_at).toLocaleDateString('en-US',{month:'short',day:'numeric'});
            if (window.confirm(`A VOB was already requested for this client on ${when} by ${p.by} (ref ${p.ref_code}, status: ${p.status}).\n\nSend it AGAIN anyway?`)) {
              const j2 = await act(`/api/leads/v2/${leadId}/request-vob`, { force: true });
              if (j2.ok) alert(`VOB requested from Biller\nRef: ${j2.ref_code}`);
            }
          } else alert('Error: ' + j0.error);
        }}>📋 Request VOB</button>
        <button disabled={busy} style={s.btnBlue} title="TCIO asks the plan electronically and fills in the VOB" onClick={async () => {
          await save();   // what's on screen is what the check sees
          const ask = async (again) => { const r = await fetch(`${API}/api/vob/workspace/${leadId}/check`, { method:'POST', headers: jh, body: JSON.stringify(again ? { again: true } : {}) }); return r.json().catch(() => ({})); };
          const openVob = () => { try { localStorage.setItem('tcio_vob_open_lead', leadId); } catch (e) { /* storage unavailable */ } window.dispatchEvent(new Event('tcio:open-vob')); };
          setBusy(true); let j;
          try { j = await ask(false); if (j.repeat) { if (!window.confirm(`${j.error}\n\nRun it again anyway?`)) { setBusy(false); return; } j = await ask(true); } } catch (e) { j = { error: e.message }; }
          setBusy(false);
          if (j.ok && j.status === 'answered') { await load(); if (window.confirm(`${j.message}\n\nAsked: ${j.plan_asked}\n${j.open} question${j.open === 1 ? '' : 's'} still to ask by phone.\n\nOpen the VOB now?`)) openVob(); }
          else if (j.ok) { if (window.confirm(`The plan did not answer the electronic check.\n\n${j.message}\n\nOpen the VOB to look at it?`)) openVob(); }
          else if (j.needs === 'plan') { if (window.confirm(`${j.error}\n\nOpen the VOB now?`)) openVob(); }
          else alert(j.error || 'The electronic VOB did not run');
        }}>⚡ Electronic VOB</button>
        <button disabled={busy} onClick={() => {
          const dt = prompt('Callback when? (2026-07-13 14:00)');
          if (dt) act(`/api/leads/v2/${leadId}/callback`, { callback_at: dt }, 'PATCH');
        }} style={s.btn}>⏰ Set Callback</button>
        <button disabled={busy || hist?.do_not_admit}
          onClick={() => hist?.do_not_admit
            ? alert('This person is flagged DO NOT ADMIT.\n\n' + hist.dna_reason)
            : setShowPending(!showPending)}
          style={{ ...s.btnGreen, opacity: hist?.do_not_admit ? 0.4 : 1,
                   cursor: hist?.do_not_admit ? 'not-allowed' : 'pointer' }}>
          → Pending Admit
        </button>
        <button disabled={busy} onClick={() => {
          const r = prompt('Lost — why?');
          if (r) act(`/api/leads/v2/${leadId}/stage`, { stage:'lost', lost_reason:r }, 'PATCH');
        }} style={s.btnRed}>Mark Lost</button>
        {lead.pipeline_stage === 'not_viable' ? (
          <button disabled={busy} onClick={async () => {
            const j = await act(`/api/leads/v2/${leadId}/restore`, {});
            if (j.ok) alert('Restored to stage: ' + j.restored_to);
          }} style={{ ...s.btn, color:'#166534', borderColor:'#86efac' }}>↩ Restore Lead</button>
        ) : (
          <select id="nvReasonSel" defaultValue="" disabled={busy} onChange={e => {
            const picked = e.target.value; if (!picked) return;
            e.target.value = '';
            if (window.confirm('Mark this lead Not Viable — ' + picked + '?'))
              act(`/api/leads/v2/${leadId}/stage`, { stage:'not_viable', lost_reason:'Not viable: ' + picked }, 'PATCH');
          }} style={{ ...s.btn, color:'#991b1b', borderColor:'#fca5a5', cursor:'pointer' }}>
            <option value="">🚫 Not Viable…</option>
            {['Not seeking treatment','Out of area','Wrong fit / LOC','Bystander / third party','AI misclassified','Other'].map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        )}
      </div>

      {lead.callback_at && <div style={s.callback}>⏰ Callback: {when(lead.callback_at)}</div>}

      {showPending && (
        <div style={{ ...s.card, background:'#f0fdf4', borderColor:'#bbf7d0' }}>
          <div style={s.cardTitle}>Move to Pending Admit — everything carries over</div>
          {!vob?.payer_name && <div style={s.warn}>⚠️ No payer on file. Continue anyway?</div>}
          <div style={{ display:'flex', gap:10, alignItems:'flex-end', marginTop:10, flexWrap:'wrap' }}>
            <div>
              <label style={s.label}>Facility (bed board)</label>
              <select id="pa-facility" style={s.input} defaultValue={lead.facility_id || ''}>
                <option value="">{'\u2014'} Select facility {'\u2014'}</option>
                {paOrgs.map(o => <option key={o.id} value={o.id}>{o.display_name || o.org_name}</option>)}
              </select>
            </div>
            <div>
              <label style={s.label}>Expected admit date</label>
              <input type="date" id="pa-date" style={s.input} />
            </div>
            <button disabled={busy} style={s.btnGreen} onClick={() => {
              const fac = document.getElementById('pa-facility').value;
              if (!fac) { alert('Pick the facility whose bed board this client belongs on.'); return; }
              act(`/api/leads/v2/${leadId}/to-pending-admit`, {
                expected_admit_date: document.getElementById('pa-date').value || null,
                facility_id: fac
              }).then(() => { setShowPending(false); alert('On the Bed Board under Pending Admits.'); });
            }}>Confirm</button>
            <button onClick={() => setShowPending(false)} style={s.btn}>Cancel</button>
          </div>
        </div>
      )}

      {/* TABS */}
      <div style={s.tabs}>
        {[{k:'timeline',l:'Timeline'},
          {k:'transcripts',l:`Calls & AI (${transcripts.length})`},
          {k:'notes',l:'Notes'}].map(t => (
          <button key={t.k} onClick={() => setTab(t.k)} style={{
            ...s.tab,
            borderBottom: tab===t.k ? '2px solid #1e40af' : '2px solid transparent',
            color: tab===t.k ? '#1e40af' : '#64748b',
            fontWeight: tab===t.k ? 700 : 400
          }}>{t.l}</button>
        ))}
      </div>

      {tab === 'timeline' && (activity.length === 0
        ? <div style={s.empty}>No activity yet.</div>
        : activity.map(a => (
          <div key={a.id} style={s.event}>
            <div style={{ flex:1 }}>
              <span style={{ fontWeight:600, color:'#334155' }}>{a.activity_type.replace(/_/g,' ')}</span>
              {a.old_value && a.new_value && <span style={s.dim}> · {a.old_value} → {a.new_value}</span>}
              {a.new_value && !a.old_value && <span style={s.dim}> · {a.new_value}</span>}
              {a.note && <div style={{ fontSize:13, color:'#475569', marginTop:2 }}>{a.note}</div>}
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={s.dim}>{a.first_name} {a.last_name}</div>
              <div style={s.dim}>{when(a.created_at)}</div>
            </div>
          </div>
        )))}

      {tab === 'transcripts' && (
        <div style={{ marginBottom: 16, border: '2px solid #c7d2fe', background: '#f5f7ff', borderRadius: 12, padding: 14 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:8 }}>
            <div style={{ fontWeight:800, fontSize:15, color:'#3730a3' }}>🤖 Lead AI — sales assist</div>
            <button onClick={() => runLeadAi()} disabled={aiBusy}
              style={{ background:'#4338ca', color:'white', border:'none', padding:'8px 16px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:13 }}>
              {aiBusy ? 'Reading calls…' : 'Re-run AI on all calls'}
            </button>
          </div>
          {aiErr && <div style={{ marginTop:6, color:'#b91c1c', fontSize:13 }}>{aiErr}</div>}
          {(psWriting || psDone) && (
            <div style={{ marginTop:8, background: psDone.startsWith('\u2713') ? '#ECFDF5' : psDone.startsWith('Prescreen generation failed') ? '#FEF2F2' : '#EFF6FF', border: '1px solid ' + (psDone.startsWith('\u2713') ? '#6EE7B7' : psDone.startsWith('Prescreen generation failed') ? '#FCA5A5' : '#93C5FD'), borderRadius:8, padding:'10px 14px', fontSize:12.5, color:'#1F2937' }}>
              {psWriting ? 'Writing the prescreen document\u2026' : psDone}
            </div>
          )}

          {ai && (
            <div style={{ marginTop:10 }}>
              {ai.urgency && (
                <div style={{ background: URGENCY_STYLE[ai.urgency.level]?.bg || '#f1f5f9', color: URGENCY_STYLE[ai.urgency.level]?.fg || '#334155', borderRadius:10, padding:'10px 14px', fontSize:13 }}>
                  <span style={{ fontWeight:800, fontSize:14 }}>{URGENCY_STYLE[ai.urgency.level]?.label || ai.urgency.level}</span>
                  <span style={{ marginLeft:8 }}>{ai.urgency.why}</span>
                </div>
              )}
              {Object.keys(ai.fills || {}).length > 0 && (
                <div style={{ marginTop:8, fontSize:12, color:'#16a34a', fontWeight:600 }}>
                  ✓ Auto-filled {Object.keys(ai.fills).length} empty field{Object.keys(ai.fills).length===1?'':'s'}: {Object.keys(ai.fills).map(k=>k.replace(/_/g,' ')).join(', ')}
                </div>
              )}
              {(ai.close_signals || []).length > 0 && (
                <div style={{ marginTop:10, background:'white', borderRadius:10, padding:12, border:'1px solid #bbf7d0' }}>
                  <div style={{ fontWeight:700, fontSize:13, color:'#15803d' }}>💚 Close signals — their own words</div>
                  {ai.close_signals.map((c,i) => <div key={i} style={{ fontSize:12, color:'#334155', marginTop:4 }}>• {c}</div>)}
                </div>
              )}
              {(ai.objections || []).length > 0 && (
                <div style={{ marginTop:8, background:'white', borderRadius:10, padding:12, border:'1px solid #fde68a' }}>
                  <div style={{ fontWeight:700, fontSize:13, color:'#92400e' }}>🧱 Objections & responses</div>
                  {ai.objections.map((o,i) => (
                    <div key={i} style={{ fontSize:12, marginTop:6 }}>
                      <div style={{ color:'#7c2d12', fontWeight:600 }}>{o.objection}</div>
                      <div style={{ color:'#334155' }}>→ {o.response}</div>
                    </div>
                  ))}
                </div>
              )}
              {(ai.next_questions || []).length > 0 && (
                <div style={{ marginTop:8, background:'white', borderRadius:10, padding:12, border:'1px solid #c7d2fe' }}>
                  <div style={{ fontWeight:700, fontSize:13, color:'#3730a3' }}>❓ Ask on the next call</div>
                  {ai.next_questions.map((q,i) => <div key={i} style={{ fontSize:12, color:'#334155', marginTop:4 }}>• {q}</div>)}
                </div>
              )}
            </div>
          )}

          <div style={{ marginTop:12, display:'flex', gap:8, alignItems:'flex-start' }}>
            <button onClick={toggleMic}
              style={{ background: listening ? '#dc2626' : 'white', color: listening ? 'white' : '#4338ca', border:'1px solid #c7d2fe', width:38, height:38, borderRadius:8, cursor:'pointer', fontSize:16 }}
              title={listening ? 'Stop' : 'Dictate'}>
              {listening ? '⏹' : '🎤'}
            </button>
            <textarea value={dict} onChange={e => setDict(e.target.value)}
              placeholder="Dictate after a call — 'answered, still using, wants in Friday, mom is paying' — Send files the note and fills fields."
              style={{ flex:1, minHeight:50, padding:8, borderRadius:8, border:'1px solid #c7d2fe', fontSize:13, fontFamily:'inherit' }} />
            <button onClick={() => runLeadAi(dict)} disabled={aiBusy || !dict.trim()}
              style={{ background: dict.trim() ? '#4338ca' : '#c7d2fe', color:'white', border:'none', padding:'8px 14px', borderRadius:8, cursor:'pointer', fontWeight:700, fontSize:13 }}>
              Send
            </button>
          </div>
        </div>
      )}
      {tab === 'transcripts' && (transcripts.length === 0
        ? <div style={s.empty}>No calls yet.</div>
        : transcripts.map(t => (
          <div key={t.callrail_id} style={s.card}>
            <div style={s.rowBetween}>
              <div>
                <span style={{ fontWeight:700 }}>{when(t.call_started_at)}</span>
                <span style={s.dim}> · {dur(t.duration_seconds)} · {t.direction}</span>
              </div>
              {t.call_id && <button onClick={() => playCall(t.call_id)} style={s.btn}>
                {playing === t.call_id ? '■ Stop' : '▶ Play'}
              </button>}
            </div>
            {playing === t.call_id && t._audio &&
              <audio controls autoPlay src={t._audio} style={{ width:'100%', marginTop:10 }} />}
            {t.transcript_status === 'complete' && t.transcript
              ? <pre style={s.transcript}>{t.transcript}</pre>
              : t.transcript_status === 'blocked_no_baa'
              ? <div style={s.warn}>Transcription blocked — Deepgram BAA not signed.</div>
              : t.transcript_status === 'failed'
              ? <div style={s.warn}>Transcription failed.</div>
              : <div style={s.dim}>Transcribing…</div>}
          </div>
        )))}

      {tab === 'notes' && (
        <div>
          <div style={{ display:'flex', gap:8, marginBottom:16 }}>
            <textarea value={noteText} onChange={e => setNoteText(e.target.value)}
              placeholder="Add a note…" style={{ ...s.input, flex:1, height:70, resize:'vertical' }} />
            <button disabled={busy || !noteText.trim()} style={s.btnGreen}
              onClick={() => act(`/api/leads/v2/${leadId}/note`, { note: noteText }).then(() => setNoteText(''))}>
              Save
            </button>
          </div>
          {activity.filter(a => ['note','call_logged'].includes(a.activity_type)).map(a => (
            <div key={a.id} style={s.card}>
              {a.activity_type === 'call_logged' &&
                <div style={{ fontSize:10.5, fontWeight:800, color:'#64748b', textTransform:'uppercase',
                  letterSpacing:'0.05em', marginBottom:3 }}>Call logged</div>}
              <div style={{ fontSize:14, color:'#334155' }}>{a.note}</div>
              <div style={{ ...s.dim, marginTop:6 }}>{a.first_name} {a.last_name} · {when(a.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const Section = ({ title }) => (
  <div style={{ fontSize:11, fontWeight:800, color:'#94a3b8', textTransform:'uppercase',
                letterSpacing:'0.06em', margin:'18px 0 8px', paddingBottom:4,
                borderBottom:'1px solid #f1f5f9' }}>{title}</div>
);

const Grid = ({ children }) => (
  <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'10px 14px' }}>
    {children}
  </div>
);

function F({ l, v, on, show, edit, opts, type='text', wide, onAdd, searchable }) {
  const style = wide ? { gridColumn:'span 2' } : {};
  if (!edit) {
    return (
      <div style={style}>
        <div style={s.label}>{l}</div>
        <div style={{ fontSize:14, color: show ? '#0f172a' : '#cbd5e1', marginTop:2 }}>
          {show || '—'}
        </div>
      </div>
    );
  }
  return (
    <div style={style}>
      <div style={s.label}>
        {l}
        {onAdd && <button onClick={onAdd} style={s.addBtn}>+ Add</button>}
      </div>
      {opts && searchable ? (
        <span>
          <input list={'dl-' + l.replace(/\W/g, '')} value={v ?? ''} onChange={e => on(e.target.value)}
            placeholder="Type to search…" style={{ ...s.input, width:'100%' }} />
          <datalist id={'dl-' + l.replace(/\W/g, '')}>
            {opts.filter(Boolean).map(o => <option key={o} value={o} />)}
          </datalist>
        </span>
      ) : opts ? (
        <select value={v ?? ''} onChange={e => on(e.target.value)} style={{ ...s.input, width:'100%' }}>
          {opts.map(o => Array.isArray(o)
            ? <option key={o[0]} value={o[0]}>{o[1]}</option>
            : <option key={o} value={o}>{o || '—'}</option>)}
        </select>
      ) : (
        <input type={type} value={v ?? ''} onChange={e => on(e.target.value)}
          style={{ ...s.input, width:'100%' }} />
      )}
    </div>
  );
}

const M = ({ label, v, green }) => (
  <div>
    <div style={{ fontSize:10, fontWeight:700, color:'#94a3b8', textTransform:'uppercase' }}>{label}</div>
    <div style={{ fontSize:18, fontWeight:700, color: green ? '#16a34a' : '#0f172a', marginTop:2 }}>{v}</div>
  </div>
);

const s = {
  wrap: { padding:24, maxWidth:1100, margin:'0 auto' },
  back: { background:'none', border:'none', color:'#64748b', fontSize:13, cursor:'pointer', padding:0, marginBottom:16 },
  header: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20, flexWrap:'wrap', gap:12 },
  rowBetween: { display:'flex', justifyContent:'space-between', alignItems:'center' },
  h1: { fontSize:24, fontWeight:800, color:'#0f172a', margin:0 },
  dim: { fontSize:13, color:'#94a3b8' },
  coldFlag: { background:'#fef3c7', color:'#92400e', fontSize:11, fontWeight:700, borderRadius:6, padding:'3px 8px' },
  card: { background:'#fff', border:'1px solid #e2e8f0', borderRadius:10, padding:16, marginBottom:12 },
  cardTitle: { fontSize:12, fontWeight:700, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.05em' },
  tierBig: { color:'#fff', fontSize:13, fontWeight:800, borderRadius:6, padding:'3px 10px' },
  actions: { display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' },
  btn: { background:'#f1f5f9', color:'#475569', border:'none', borderRadius:8, padding:'9px 16px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnCall: { background:'#16a34a', color:'#fff', border:'none', borderRadius:8, padding:'9px 16px', fontSize:13, fontWeight:700, cursor:'pointer' },
  btnBlue: { background:'#2563eb', color:'#fff', border:'none', borderRadius:8, padding:'9px 16px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnGreen: { background:'#16a34a', color:'#fff', border:'none', borderRadius:8, padding:'9px 16px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnRed: { background:'#fee2e2', color:'#991b1b', border:'none', borderRadius:8, padding:'9px 16px', fontSize:13, fontWeight:600, cursor:'pointer' },
  addBtn: { marginLeft:6, background:'none', border:'none', color:'#2563eb', fontSize:10, fontWeight:700, cursor:'pointer', padding:0 },
  callback: { background:'#fee2e2', color:'#991b1b', padding:'8px 12px', borderRadius:6, fontSize:13, fontWeight:600, marginBottom:16 },
  warn: { background:'#fef3c7', color:'#92400e', padding:'8px 12px', borderRadius:6, fontSize:13, marginTop:8 },
  tabs: { display:'flex', gap:4, borderBottom:'1px solid #e2e8f0', marginBottom:16 },
  tab: { background:'none', border:'none', padding:'10px 16px', fontSize:14, cursor:'pointer', marginBottom:-1 },
  event: { display:'flex', justifyContent:'space-between', padding:'12px 0', borderBottom:'1px solid #f1f5f9', fontSize:14 },
  transcript: { marginTop:12, padding:12, background:'#f8fafc', borderRadius:6, fontSize:13, lineHeight:1.6, color:'#334155', whiteSpace:'pre-wrap', fontFamily:'inherit', maxHeight:400, overflowY:'auto' },
  input: { padding:'7px 9px', borderRadius:6, border:'1px solid #cbd5e1', fontSize:13, boxSizing:'border-box' },
  label: { fontSize:10, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', letterSpacing:'0.04em' },
  empty: { padding:40, textAlign:'center', color:'#94a3b8' },
  dnaBanner: { background:'#dc2626', color:'#fff', borderRadius:10, padding:16, marginBottom:12 },
  dnaClear: { marginTop:10, background:'rgba(255,255,255,0.2)', color:'#fff',
              border:'1px solid rgba(255,255,255,0.4)', borderRadius:6,
              padding:'6px 12px', fontSize:12, fontWeight:600, cursor:'pointer' },
  hTh: { padding:'5px 8px', textAlign:'left', fontSize:10, fontWeight:800,
         color:'#92400e', textTransform:'uppercase' },
  hTd: { padding:'6px 8px', color:'#78350f' },
};